import * as defaults from './defaults';
export var SORT_OPTIONS = {
  SOLD: {
    label: 'Sold',
    value: {
      type: 'SELL',
      allLocations: false
    },
    statTitle: 'Sales in '
  },
  SOLD_TOTAL: {
    label: 'Sold (total sales)',
    value: {
      type: 'SELL',
      allLocations: true
    },
    statTitle: 'Sales in '
  },
  RENTED: {
    label: 'Rented',
    value: {
      type: 'RENT',
      allLocations: false
    },
    statTitle: 'Rentals in '
  },
  RENTED_TOTAL: {
    label: 'Rented (total rentals)',
    value: {
      type: 'RENT',
      allLocations: true
    },
    statTitle: 'Rentals in '
  },
  DEVELOPMENT: {
    label: 'New homes sold',
    value: {
      type: 'DEVELOPMENT',
      allLocations: false
    },
    statTitle: 'New Homes in '
  },
  DEVELOPMENT_TOTAL: {
    label: 'New homes (total sales)',
    value: {
      type: 'DEVELOPMENT',
      allLocations: true
    },
    statTitle: 'New Homes in '
  }
};
export var fromUrlQuery = _ref => {
  var sort = _ref.sort;
  return sort && sort.toUpperCase();
};
export var toUrlQuery = _ref2 => {
  var sort = _ref2.sort;
  return {
    sort: !sort || sort === defaults.sort ? undefined : sort.toLowerCase()
  };
};